<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Affiliate Used Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <router-link to="/lps/report/view/affiliate">Reports</router-link>
      /
      <router-link to="/lps/report/view/affiliate">Affiliate</router-link>
      /
      <b>Used</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class="">
              <!-- Active -->

              <div class="row">
                <div class="col-12 col-lg-6 col-sm-12">
                  <h4 class="card-title mb-3">
                    <b
                      >Referral Code Usage Report for:
                      {{ referral_details.affiliate.name }} ({{
                        referral_details.account_number
                      }})</b
                    >
                  </h4>
                  <p>The table shows the referral code usage report.</p>
                </div>

                <div class="col-12 col-lg-6 col-sm-12 align-items-center">
                  <h4 class="card-title mb-3 text-right">
                    <b style="font-size: 20px">
                      <label>Total Used: {{ total_used }}</label>
                    </b>
                  </h4>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <label><b>Date From</b></label>
                  <input type="date" class="form-control" v-model="dateFrom" />
                </div>
                <div class="col-6">
                  <label><b>Date To</b></label>
                  <input type="date" class="form-control" v-model="dateTo" />
                </div>
              </div>

              <br />

              <div class="text-left">
                {{
                  dateFromFormatted != null && dateToFormatted != null
                    ? `Report Date from ${dateFromFormatted} to ${dateToFormatted}`
                    : ""
                }}
              </div>

              <div class="text-right">
                <button
                  class="btn btn-rounded btn-primary mr-2"
                  style="width: 150px"
                  @click="filterSearch()"
                >
                  Filter
                </button>
                <button
                  class="btn btn-rounded btn-primary"
                  style="width: 150px"
                  @click="resetFilter()"
                >
                  Reset
                </button>
              </div>

              <br />

              <div class="table-responsive"></div>
              <table
                id="payout_tbl"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Account Number</th>
                    <th>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in lists" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ list.recipient.account_number }}</td>
                    <td>{{ list.created_at }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      lists: [],
      total_used: 0,

      dateFrom: null,
      dateTo: null,
      dateFromFormatted: null,
      dateToFormatted: null,
      referral_details: {},
    };
  },

  methods: {
    loadDetails() {
      if (this.checkToken() == false) {
        swal({
          icon: "error",
          text: "You are not authorised",
        });
        return;
      }

      let id = this.$route.params.id;
  axios
        .get(axios.lpsURL + "/referral_code/" + id, {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        })
        .then((res) => {
          this.referral_details = res.data;
        });

      axios
        .get(axios.lpsURL + "/referral_code/used/" + id, {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        })
        .then((res) => {
          this.total_used = 0;

          this.lists = res.data.data;
          this.total_used = res.data.total_used;
        })
        .then(() => {
          this.destroyDatatable();
          this.createDatatable(this.referral_details.account_number);
        });

            

   
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    destroyDatatable() {
      $("#payout_tbl").DataTable().destroy();
    },

    createDatatable(name) {
      $("#payout_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
         buttons: [
          {
            extend: "excelHtml5",
            filename: `Referral Code (${name}) Usage Report`,
            title: `Referral Code (${name}) Usage Report`,

          },
          {
            extend: "pdfHtml5",
            filename: `Referral Code (${name}) Usage Report`,
            title: `Referral Code (${name}) Usage Report`,
          }
        ]
      });
    },

    loadFilter() {
      this.destroyDatatable();

      this.dateFromFormatted = moment(this.dateFrom).format("DD MMMM YYYY");
      this.dateToFormatted = moment(this.dateTo).format("DD MMMM YYYY");

      let id = this.$route.params.id;

      axios
        .get(
          axios.lpsURL +
            `/referral_code/used/${id}?date_from=${this.dateFrom}&date_to=${this.dateTo}`,
          {
            headers: {
              Authorization: "Bearer " + this.checkToken(),
            },
          }
        )
        .then((result) => {
          this.total_used = 0;

          this.lists = result.data.data;
          this.total_used = res.data.total_used;
        })
        .then(() => {
          this.createDatatable(this.referral_details.account_number);
        });
    },

    filterSearch() {
      this.isLoading = true;
      this.loadFilter();
      this.isLoading = false;
    },

    resetFilter() {
      this.destroyDatatable();

      this.loadDetails();
      this.dateFromFormatted = null;
      this.dateToFormatted = null;
      this.dateFrom = null;
      this.dateTo = null;
    },
  },

  mounted() {
    this.loadDetails();
  },
};
</script>
